import { Button, Modal, Stack } from "react-bootstrap";
import { ICaseResolutionModel, ICaseResolutionPlanStepHistoryModel, ICaseResolutionPlanStepModel } from "../../../../interfaces/ICaseResolutionModel";
import { IUserModel } from "../../../../interfaces/IUser";
import Common from "../../../../stores/Common";

export interface WorkLogProps {
    caseResolutionCase: ICaseResolutionModel;
    caseHistory: ICaseResolutionPlanStepHistoryModel[] | undefined;
    users: IUserModel[];
    onHide: () => void;
    open: boolean;
}

export function WorkLog({
    caseResolutionCase,
    caseHistory,
    users,
    onHide,
    open
}: WorkLogProps) {

    const activeHistory = caseHistory;

    const getUser = (userId: string) => {
        const user = users.find(u => u.guid === userId);
        if(user) {
            return user?.profile?.firstName! + " " + user?.profile?.lastName!;
        }
        return "";
    }

    const getWorkText = (workItem: ICaseResolutionPlanStepHistoryModel, index: number) => {
        const currentStep = caseResolutionCase.steps.find(x => x.stepId === workItem.caseResolutionPlanStepId);
        const user = getUser(workItem.historyUserId);
        if (workItem.isCompleted) {
            return (
                <label className="bold" style={{ color: '#4abdac'}}>
                    {user} Completed Step {currentStep!.name}
                </label>
            )
        }
        else {
            return (
                <label className="bold" style={{ color: '#ff0000'}}>
                    {user} Rejected Step {currentStep!.name}
                </label>
            )
        }
    }

    const getStepNotes = (workItem: ICaseResolutionPlanStepHistoryModel, index: number) => {
        let planStepNotes = '';
        if(workItem.stepData){
           planStepNotes =  workItem.stepData?.notes ?? '';
        }
        return planStepNotes;
    }

    return (
            <Modal
                centered
                show={open}
                dialogClassName="official-case-doc-dialog-fullwidth"
                size="xl"
                //onHide={onHide}
                backdrop={false}
            >
                <Modal.Header>
                    <Modal.Title>
                        Work Log For {caseResolutionCase.caseName} Case Resolution
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="pb-3">
                        {activeHistory && (
                            <div className="table-responsive">
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '15%' }}>User</th>
                                            <th style={{ width: '15%' }}>Step</th>
                                            <th style={{ width: '10%' }}>Date</th>
                                            <th className="notes-col">Notes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activeHistory.length > 0 ? (
                                            activeHistory.map((workItem: ICaseResolutionPlanStepHistoryModel, i: number) => {
                                                if (!workItem.caseResolutionPlanStepId) return null;
                                                const currentStep = caseResolutionCase.steps.find(
                                                    x => x.stepId === workItem.caseResolutionPlanStepId
                                                );
                                                const user = getUser(workItem.historyUserId);
                                                if (!currentStep) return null;

                                                return (
                                                    <tr key={i}>
                                                        <td>{user!}</td>
                                                        <td>{currentStep.name}</td>
                                                        <td>{Common.dateTimeFormatToLocal(workItem.historyDate)}</td>
                                                        <td>{getStepNotes(workItem, i)}</td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={4}>
                                                    <div className="padding-bottom-med">
                                                        <Stack
                                                            direction="horizontal"
                                                            style={{ columnGap: '0.5rem', flexWrap: 'wrap' }}
                                                        >
                                                            <div>
                                                                <label className="bold">No Work History Logged</label>
                                                            </div>
                                                        </Stack>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={onHide}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
    );
}